import * as _ from 'lodash';
import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import Locator from '../../../../../../shared/Locator';
import { isFreeTier } from '../../../../../../shared/subscriptions';
import { window } from '../../../../../globals';
import * as ReportGenerationStore from '../../../../../redux/reportGeneration';
import { nuc } from '../../../../../utils';
import PaidFeatureGate from '../../../../generic/Gates/PaidFeatureGate';
import { SidebarLayout } from '../../../../layouts';
import Panel from '../shared/components/Settings';
import { useSaveReportSettings } from '../shared/hooks';
import Sidebar from '../Sidebar';
import type { ProjectContext, ReportGenerationParams } from '../../shared/types';

import styles from './ProjectLevelReport.module.less';

type Props = {
  params: ReportGenerationParams;
};

const ProjectReportSettings: VoidFunctionComponent<Props> = ({ params }) => {
  const isPaidFeatureGateRestricted = isFreeTier({
    plan: window?.user?.organization?.stripe_plan,
    stripePriceLimit: window?.user?.organization?.stripePriceLimit,
  });
  const reportContext = useSelector(ReportGenerationStore.selectors.getReportContext) as ProjectContext;
  const locator = Locator.parsePackageString(reportContext.revision);
  const organizationId = window.user?.organization?.id;

  const onSave = useSaveReportSettings({
    projectLocator: nuc(locator),
    organizationId: organizationId!,
  });

  return (
    <div className={styles.settings}>
      <SidebarLayout>
        <SidebarLayout.Main>
          <div className={styles.layout}>
            <Sidebar params={params} resetFormat={_.noop} />
            <PaidFeatureGate isRestricted={isPaidFeatureGateRestricted} hidePill>
              <Panel
                onSave={organizationId ? onSave : async () => {}}
              />
            </PaidFeatureGate>
          </div>
        </SidebarLayout.Main>
      </SidebarLayout>
    </div>
  );
};

export default ProjectReportSettings;
